import { Icon, IconSize, IconVariants, Slider, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { Col, Row } from "@/components";
import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";

import { SliderWrapperProps } from "../types";

export function InferenceCard({
  minValue,
  maxValue,
  value,
  onChange,
  isDisabled,
  infoLink,
  label,
  description,
  area_label,
  step,
}: SliderWrapperProps) {
  return (
    <Col className="gap-1">
      <Row className="gap-1 items-center">
        <Text variant={TextVariants.LABEL_LARGE_MEDIUM} className="text-gray-12 dark:text-gray-12">
          {label}
        </Text>
        <LocalizedLink target="_blank" to={infoLink} className="flex items-center" aria-label={area_label}>
          <Icon icon={IconVariants.INFO} size={IconSize.SMALL} className="text-gray-10" />
        </LocalizedLink>
      </Row>
      <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-gray-11">
        {description}
      </Text>
      <Slider min={minValue} max={maxValue} step={step} value={value} onChange={onChange} aria-labelledby={area_label} disabled={isDisabled} />
    </Col>
  );
}
